import React, { Component } from "react";
import { Provider } from "react-redux";
import Store from "./Store";
import Dashboard from "./Dashboard";
import UnloadMessage from "../components/global-unloadMessage/UnloadMessage";
import GlobalMessages from "../components/global-messages/ApplicationMessage";
import GlobalNotifications from "../components/global-messages/GlobalNotifications";
import InternalStateService from "./InternalStateService";
//returns a component if its defined and its activation flag is defined as a global property
//returns <></> otherwise
const getComponentIfAvailable = ({
    componentName,
    componentProps = {},
    globalPropertyFlag
} = {}) => {
    if (globalPropertyFlag !== undefined) {
        if (!InternalStateService.getGlobalProperties(globalPropertyFlag)) {
            return <></>;
        }
    }
    const Component = InternalStateService.getComponent(componentName);
    if (Component) {
        return <Component {...componentProps}></Component>;
    } else {
        return <></>;
    }
};

export default class App extends Component {
    constructor(props) {
        super(props);
        const { store } = Store.init();
        InternalStateService.setDispatchMethod(store.dispatch);
        this.state = {
            store: store
        };
        //initial request for switch dashboard action
        if (InternalStateService.getGlobalProperties("skipAppBoot")) {
            let preloaded = InternalStateService.getGlobalProperty("preMadeRequests");
            if (preloaded) {
                store.dispatch(
                    InternalStateService.getActionByName("application.loadBootDashboard")(
                        preloaded.dashboardResult
                    )
                );
            } else {
                store.dispatch(
                    InternalStateService.getActionByName("application.loadBootDashboard")()
                );
            }
        } else {
            store.dispatch(InternalStateService.getActionByName("application.loadAppBoot")());
        }
    }
    render() {
        let Messages = GlobalMessages;
        let globalMessagesProps = {};
        if (InternalStateService.getGlobalProperties("modalDialogMessages")) {
            Messages = InternalStateService.getComponent("modalDialog") || "div";
        }
        if (InternalStateService.getGlobalProperties("globalMessagesProps")) {
            globalMessagesProps = InternalStateService.getGlobalProperties("globalMessagesProps");
        }
        let globalNotificationsProps = {};
        if (InternalStateService.getGlobalProperties("globalNotificationsProps")) {
            globalNotificationsProps = InternalStateService.getGlobalProperties(
                "globalNotificationsProps"
            );
        }
        let OnBeforeUnloadMessage =
            InternalStateService.getComponent("unloadMessage") || UnloadMessage;

        const additionalGlobalComponents = (
            <>
                {getComponentIfAvailable({ componentName: "globalLoading" })}
                {getComponentIfAvailable({
                    componentName: "applicationLoading",
                    globalPropertyFlag: "applicationLoadingAnimation"
                })}
                {getComponentIfAvailable({ componentName: "globalTheme" })}
                {getComponentIfAvailable({ componentName: "globalComponent" })}
                {getComponentIfAvailable({
                    componentName: "pushMessage",
                    globalPropertyFlag: "applicationPushMessages"
                })}
            </>
        );
        return (
            <Provider store={this.state.store}>
                {additionalGlobalComponents}
                <OnBeforeUnloadMessage />
                <Messages {...globalMessagesProps} />
                <GlobalNotifications {...globalNotificationsProps} />
                <Dashboard />
            </Provider>
        );
    }
}
